import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import '@mdi/font/css/materialdesignicons.css'
import pt from 'vuetify/es5/locale/pt'
import en from 'vuetify/es5/locale/en'
import es from 'vuetify/es5/locale/es'
import i18n from '../i18n'

const messages = i18n.messages

Vue.use(Vuetify, { iconfont: 'mdi' })

export default new Vuetify({
  icons: {
    iconfont: 'mdi' // default - only for display purposes
  },
  theme: {
    themes: {
      light: {
        primary: '#009280',
        secondary: '#424242',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107'
      }
    }
  },
  lang: {
    locales: { en: { ...messages.en, ...en }, pt: { ...messages.pt, ...pt }, pt_BR: { ...messages.pt, ...pt }, es: { ...messages.es, ...es } },
    current: 'pt_BR'
  }
})
